import Chart from 'chart.js/auto'

const GoldChart = (function () {

    const chartElement = document.getElementById('goldChart');
    const timePeriodSelect = document.getElementById('timePeriod');
    const loader = document.querySelector('.chartLoader');
    const chartContainer = document.querySelector('.chartContainer');
    const priceDisplay = document.getElementById('priceToday');
    let goldPriceChart;

    if (!chartElement) return;

     document.addEventListener('DOMContentLoaded', function () {
        initChart();
        setupEventListeners();
    });


    function setupEventListeners() {
        timePeriodSelect.addEventListener('change', updateChart);
    }

    function toggleVisibility(isLoading) {
        if (isLoading) {
            loader.classList.remove('hidden');
            chartContainer.classList.add('hidden');
        } else {
            loader.classList.add('hidden');
            chartContainer.classList.remove('hidden');
        }
    }

    function fetchData(days) {
        const apiUrl = `https://api.nbp.pl/api/cenyzlota/last/${days}/?format=json`;
        toggleVisibility(true);

        return fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    const relevantData = data.slice(-Math.min(days, data.length));
                    return {
                        dates: relevantData.map(entry => entry.data),
                        prices: relevantData.map(entry => entry.cena)
                    };
                } else {
                    throw new Error('No data available');
                }
            });
    }

    function createChart(dates, prices) {
        const ctx = chartElement.getContext('2d');
        goldPriceChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: dates,
                datasets: [{
                    label: 'cena 1 g złota (PLN)',
                    backgroundColor: 'rgba(255, 215, 0, 0.2)',
                    borderColor: '#c5aa8a',
                    borderWidth: 1,
                    data: prices
                }]
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: false
                    }
                }
            }
        });
    }


    function initChart() {
        fetchData(7).then(({dates, prices}) => {
            createChart(dates, prices);
            priceDisplay.textContent = prices[prices.length - 1];
            toggleVisibility(false);
        }).catch(error => {
            console.error('Error initializing chart:', error);
            toggleVisibility(false);
        });
    }


    function updateChart() {
        const days = timePeriodSelect.value;
        fetchData(days).then(({dates, prices}) => {
            goldPriceChart.data.labels = dates;
            goldPriceChart.data.datasets.forEach(dataset => {
                dataset.data = prices;
            });
            goldPriceChart.update();
            priceDisplay.textContent = prices[prices.length - 1];
            toggleVisibility(false);
        }).catch(error => {
            console.error('Error updating chart:', error);
            toggleVisibility(false);
        });
    }

});
export default GoldChart;


